import { render, staticRenderFns } from "./LowValueAssetsItemEdit.vue?vue&type=template&id=74ee89e1&"
import script from "./LowValueAssetsItemEdit.vue?vue&type=script&lang=js&"
export * from "./LowValueAssetsItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports